import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faTicket } from '@fortawesome/free-solid-svg-icons';
import { AuthenticationStateStore } from '@unicup-ticketing/auth';
import { ButtonComponent } from '@unicup-ticketing/ui';
import { CombinedLogoComponent } from '../combined-logo/combined-logo.component';
import { NavigationStateStore } from '../../navigation/nav-items.state';

@Component({
  selector: 'ticketing-mobile-menu',
  imports: [RouterLink, FaIconComponent, ButtonComponent, CombinedLogoComponent],
  templateUrl: './mobile-menu.component.html',
  styleUrl: './mobile-menu.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMenuComponent {
  isOpen = input.required<boolean>();
  protected readonly faTicket = faTicket;
  private readonly authState = inject(AuthenticationStateStore);
  readonly navItems = inject(NavigationStateStore).items;
  protected user = computed(() => {
    const idToken = this.authState.idToken();
    if (idToken) {
      return {
        givenName: idToken.user.givenName,
        surname: idToken.user.surname,
      };
    }
    return undefined;
  });
}
